var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('ion-button',{attrs:{"color":"light","expand":"block"},on:{"click":function($event){return _vm.$emit('clear-info')}}},[_vm._v("Clear")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }